import React, { Component } from "react";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import InitialFormDetails from "./InitialFormDetails";
import InitialChannelFormDetails from "./InitialChannelFormDetails";
import InitialContactFormDetails from "./InitialContactFormDetails";

import InitialOfflinePage from "./InitialOfflinePage";

import './InitialFormStyleSheet.css';
import { InputGroup, FormControl, Button, Image } from 'react-bootstrap';

class InitialFormContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            messages: [],
            xmppMessageHistory: [],
            isConversationClosed: false,
            showSnackBar: false,
            showSendChatTranscriptForm: false,
            showForm:false,
            showContactForm:false
        };
        this.conversationRef = React.createRef();
    }

    render() {

        return (
         
            <div className="S360-initial-form-detail-container-parent">
            {/* <div className="s360-initial-form-sub-header-message" style={this.subHeaderStyle()}>{this.props.config.configDetails.brandSubMessage}</div> */}

            <div className="s360-initial-form-detail-container" style={{overflowY:'auto'}}>
                {/* <div className="s360-initial-form-detail-container-introductionMessage" style={this.allConversationStyle()}>
                    {this.props.config.configDetails.introductionMessage}
                </div> */}
                
                {this.props.config.configDetails.offline && <InitialOfflinePage {...this.props} handleRedirect={() => { this.setState({ showForm: true }) }} handleContactForm={() => { this.setState({ showContactForm: true }) }}/>} 
                {!this.props.config.configDetails.offline  && this.props.config.channels && !this.state.showForm && !this.state.showContactForm &&  <InitialChannelFormDetails {...this.props} handleRedirect={() => { this.setState({ showForm: true }) }} handleContactForm={() => { this.setState({ showContactForm: true }) }}/>} 
                {((this.props.config.form && this.state.showForm ) || !this.props.config.channels && !this.props.config.configDetails.offline ) && <InitialFormDetails {...this.props}   showLandingPage={this.showLandingPage}/>}
                {this.props.config.contactForm && this.state.showContactForm  && !this.props.config.configDetails.offline  && <InitialContactFormDetails ref="initialContact" {...this.props} showLandingPage={this.showLandingPage} />} 
                <DefaultFooter      {...this.props} />
            </div>
            </div>
        );
    }

    // subHeaderStyle = () => {
    //     return {
    //         color:      this.props.config.designDetails.subHeaderFontColor,
    //         fontFamily: this.props.config.designDetails.subHeaderFontSize,
    //         fontSize:   this.props.config.designDetails.subHeaderFontSize,
    //     }
    //     }

    allConversationContainerStyle = () => {
        return {
            // backgroundColor: this.props.config.designDetails.pageBackgroundColor
            overflowY: "auto",
        }
    }

    allConversationStyle = () => {
        return {
            // color:      this.props.config.designDetails.headerMessageFontColor,
            fontFamily: this.props.config.designDetails.messageFont,
            fontSize:   this.props.config.designDetails.messageFontSize+"px",
            color:      this.props.config.designDetails.messageFontColor
        }
    }

    showLandingPage = () => {

        this.setState({ showContactForm: false,showForm:false}); 
    }

}

export default InitialFormContainer;